@if (uiMode == 'side') {
    <bm-dunning-type-trigger-side
            [objectIdentifier]="objectIdentifier"
            [dto]="dto"
            [uiMode]="uiMode"
            (onNavigationItems)="handleNavigationItems($event)"
    ></bm-dunning-type-trigger-side>
} @else {
    <bm-dunning-type-trigger-full
            [objectIdentifier]="objectIdentifier"
            [dto]="dto"
            [uiMode]="uiMode"
            (onNavigationItems)="handleNavigationItems($event)"
    ></bm-dunning-type-trigger-full>
}
